// extracted by mini-css-extract-plugin
module.exports = {"footerCorporative":"styles_footerCorporative__1rrqC"};